function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o)
    return; if (typeof o === "string")
    return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor)
    n = o.constructor.name; if (n === "Map" || n === "Set")
    return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length)
    len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(arr) { if (Array.isArray(arr))
    return arr; }
// Imports
import dateFormat from "dateformat";
import datepicker from "js-datepicker";
if (document.URL.includes("booking")) {
    window.onload = function () {
        document.querySelectorAll("input").value = "";
    };
    /* Visually Hidden Gravity Form Fields - (Additional Info Required)
     Skip Size & Skip Type merge together */
    var WasteType = document.getElementById("input_7_6");
    var skipType = document.getElementById("input_7_7");
    var permitType = document.getElementById("input_7_8");
    var postcodeType = document.getElementById("input_7_9");
    var deliveryDateType = document.getElementById("input_7_12");
    var collectionDateType = document.getElementById("input_7_11");
    var replacementType = document.getElementById("input_7_10");
    var subtotalType = document.getElementById("input_7_14");
    var VATType = document.getElementById("input_7_13");
    var totalType = document.getElementById("input_7_15");
    /* Additional Info Required - Booking
    Form visible user selection results */
    var additionalInfoWasteValue = document.getElementById("additional-info-waste-value");
    var additionalInfoSizeValue = document.getElementById("additional-info-size-value");
    var additionalInfoDrivewaySelection = document.getElementById("additional-info-driveway-selection");
    // Form Sections
    var waste_types_section = document.getElementById("booking_step_one");
    var types_section = document.getElementById("booking_step_two");
    var skip_types_section = document.getElementById("booking_step_skip_types");
    var skip_selected_section = document.getElementById("booking_step_three");
    var selected_driveway_section = document.getElementById("booking_step_four");
    var waste_type_section = document.getElementById("booking_step_five");
    // Form Values
    // Driveway type radio button input field
    var drivewaySelection = document.getElementById("driveway-selection");
    var collectionDateValue = document.getElementById("collection-date-value");
    var deliveryDateValue = document.getElementById("delivery-date-value");
    // Form Missing Input / Errors Content
    var WasteTypeError = document.getElementById("waste-error");
    var skipTypeError = document.getElementById("type-error");
    var drivewayError = document.getElementById("driveway-error");
    var postcodeError = document.getElementById("postcode-error");
    var deliveryDateError = document.getElementById("delivery-error");
    var collectionDateError = document.getElementById("collection-error");
    // Timeline buttons
    var timeline_progress_step_one = document.getElementById("timeline_progress_step_one");
    var timeline_progress_step_two = document.getElementById("timeline_progress_step_two");
    var timeline_progress_step_three = document.getElementById("timeline_progress_step_three");
    var timeline_progress_step_four = document.getElementById("timeline_progress_step_four");
    var timeline_progress_step_five = document.getElementById("timeline_progress_step_five");
    var timeline_progress_step_six = document.getElementById("timeline_progress_step_six");
    var submitForm = document.getElementById("submit-form");
    var booking_step_five = document.getElementById("booking_step_five");
    var booking_confirmation = document.getElementById("booking_confirmation");
    var booking_additional_info_form = document.getElementById("booking_additional_info_form");
    // Timeline buttons
    var timelineProgress = function timelineProgress() {
        // Scroll timeline behavior
        timeline_progress_step_one.addEventListener("click", function () {
            waste_types_section.scrollIntoView({
                behavior: "smooth"
            });
        });
        timeline_progress_step_two.addEventListener("click", function () {
            types_section.scrollIntoView({
                behavior: "smooth"
            });
        });
        timeline_progress_step_three.addEventListener("click", function () {
            skip_types_section.scrollIntoView({
                behavior: "smooth"
            });
        });
        timeline_progress_step_four.addEventListener("click", function () {
            skip_selected_section.scrollIntoView({
                behavior: "smooth"
            });
        });
        timeline_progress_step_five.addEventListener("click", function () {
            selected_driveway_section.scrollIntoView({
                behavior: "smooth"
            });
        });
        timeline_progress_step_six.addEventListener("click", function () {
            waste_type_section.scrollIntoView({
                behavior: "smooth"
            });
        });
        booking_confirmation.addEventListener("click", function () {
            booking_confirmation.scrollIntoView({
                behavior: "smooth"
            });
        });
        // Mobile Timeline progress
        document.addEventListener("DOMContentLoaded", function () {
            var next_steps_timeline_mobile = document.getElementById("next-steps-timeline-mobile");
            var steps = [waste_types_section, types_section, skip_types_section, skip_selected_section, selected_driveway_section, waste_type_section, booking_confirmation];
            var currentStep = 0;
            next_steps_timeline_mobile.addEventListener("click", function () {
                steps[currentStep].scrollIntoView({
                    behavior: "smooth"
                });
                currentStep = (currentStep + 1) % steps.length; // Loop back to the first step after the last step
            });
            window.addEventListener("scroll", function () {
                var scrollPosition = window.scrollY;
                var backToTopButton;
                if (scrollPosition > 200) {
                    backToTopButton.classList.remove("hidden");
                    backToTopButton.classList.add("relative", "w-fit", "h-fit", "z-[998]");
                }
                else {
                    backToTopButton.classList.add("hidden");
                    backToTopButton.classList.remove("relative", "w-fit", "h-fit", "z-[998]");
                }
            });
        });
    };
    timelineProgress();
    // Reset Form Fields
    var resetFormFields = function resetFormFields() {
        // Reset all fields when user selects or re-selects a waste type
        var postcode = document.getElementById("postcode");
        var postcode_check = document.getElementById("postcode-valid");
        // Driveway type radio button input field
        var privateDriveway = document.getElementById("private-driveway");
        var publicDriveway = document.getElementById("public-driveway");
        var drivewaysLabels = document.querySelectorAll("#driveways label");
        var privateDrivewayWrapper = document.getElementById("private-driveway-wrapper");
        var publicDrivewayWrapper = document.getElementById("public-driveway-wrapper");
        var submitPostcode = document.getElementById("submit-postcode");
        var postcodeSuccess = document.getElementById("postcode-success");
        var postcodeError = document.getElementById("postcode-error");
        var postcodeValidError = document.getElementById("postcode-valid-error");
        var postcodeValid = document.getElementById("postcode-valid");
        var replacementSkipValue = document.getElementById("replacement-skip-value");
        var wasteValue = document.getElementById("waste-value");
        var sizeValue = document.getElementById("size-value");
        var subtotalValue = document.getElementById("subtotal-value");
        var vatValue = document.getElementById("vat-value");
        var totalValue = document.getElementById("total-value");
        /* RESET TIMELINE PROGRESS STEPS */
        timeline_progress_step_two.classList.remove("active");
        timeline_progress_step_three.classList.remove("active");
        timeline_progress_step_four.classList.remove("active");
        timeline_progress_step_five.classList.remove("active");
        timeline_progress_step_six.classList.remove("active");
        /* RESET ALL INPUT FIELDS */
        if (postcode.value != "" && deliveryDateValue.value != "" && collectionDateValue.value != "" && drivewaySelection.innerHTML != "" && postcode_check.value) {
            drivewaysLabels.forEach(function (label) {
                label.classList.remove("selected");
            });
            postcode.value = "";
            postcodeSuccess.style.display = "none";
            postcodeError.style.display = "none";
            postcodeValidError.style.display = "none";
            deliveryDateValue.value = "";
            collectionDateValue.value = "";
            postcodeValid.value = "";
            replacementSkipValue.checked = false;
            wasteValue.innerHTML = "";
            sizeValue.innerHTML = "";
            subtotalValue.innerHTML = "";
            vatValue.innerHTML = "";
            totalValue.innerHTML = "";
        }
        /* DISABLE ALL INPUT FIELDS */
        // Deselect the radio button
        privateDriveway.checked = false;
        publicDriveway.checked = false;
        // Disable the input again
        privateDriveway.disabled = true;
        publicDriveway.disabled = true;
        // Enable the disable wrapper styling
        privateDrivewayWrapper.classList.remove("active");
        publicDrivewayWrapper.classList.remove("active");
        // Postcode search input fields
        postcode.disabled = true;
        postcodeValid.disabled = true;
        submitPostcode.disabled = true;
        // Datepicker (Delivery & Collection Date) input fields
        deliveryDateValue.disabled = true;
        collectionDateValue.disabled = true;
        // Form submit button
        submitForm.disabled = true;
    };
    // Reset Additional Info Required Form Fields
    var resetAdditionalInfoRequiredFormFields = function resetAdditionalInfoRequiredFormFields() {
        // FORM VISIBLE FIELDS
        // Waste Type
        additionalInfoWasteValue.value = "";
        additionalInfoWasteValue.innerHTML = "";
        additionalInfoWasteValue.placeholder = "";
        // Skip Type
        additionalInfoSizeValue.value = "";
        additionalInfoSizeValue.innerHTML = "";
        additionalInfoSizeValue.placeholder = "";
        // Permit Type
        additionalInfoDrivewaySelection.value = "";
        additionalInfoDrivewaySelection.innerHTML = "";
        additionalInfoDrivewaySelection.placeholder = "";
        // GRAVITY FORMS FIELDS //
        // Waste Type
        WasteType.value = "";
        WasteType.innerHTML = "Waste Type";
        WasteType.placeholder = "Waste Type";
        // Skip Type
        skipType.value = "";
        skipType.innerHTML = "Skip Type";
        skipType.placeholder = "Skip Type";
        // Permit Type
        permitType.value = "";
        permitType.innerHTML = "Permit Type";
        permitType.placeholder = "Permit Type";
        // Postcode
        postcodeType.value = "";
        postcodeType.innerHTML = "Postcode";
        postcodeType.placeholder = "Postcode";
        // Delivery Date
        deliveryDateType.value = "";
        deliveryDateType.innerHTML = "Delivery Date";
        deliveryDateType.placeholder = "Delivery Date";
        // Collection Date
        collectionDateType.value = "";
        collectionDateType.innerHTML = "Collection Date";
        collectionDateType.placeholder = "Collection Date";
        // Replacement
        replacementType.value = "";
        replacementType.innerHTML = "Replacement";
        replacementType.placeholder = "Replacement";
        // SubtotalType
        subtotalType.value = "";
        subtotalType.innerHTML = "Subtotal";
        subtotalType.placeholder = "Subtotal";
        // VAT Type
        VATType.value = "";
        VATType.innerHTML = "VAT";
        VATType.placeholder = "VAT";
        // Total Type
        totalType.value = "";
        totalType.innerHTML = "Total";
        totalType.placeholder = "Total";
        /* Removes Additional Info Required Form &
           Add/ Returns the user ability to order a skip */
        // Display Order & Pay Option
        booking_step_five.classList.remove("hidden");
        booking_step_five.classList.add("flex");
        booking_confirmation.classList.remove("hidden");
        booking_confirmation.classList.add("flex");
        // Removes Additional Info Required Form
        booking_additional_info_form.classList.remove("flex");
        booking_additional_info_form.classList.add("hidden");
        // Returns Timeline Progress Confirmation Text
        timeline_progress_step_six.innerHTML = "Confirmation";
    };
    /* Display Additional Info Required Form &
     Removes the user ability to order a skip */
    var displayAdditionalInfoRequiredForm = function displayAdditionalInfoRequiredForm(wasteTypeSelected, skipTypeSelected) {
        // if (
        // 	wasteTypeSelected != "Mixed" ||
        // 	skipTypeSelected.includes("enclosed") ||
        // 	skipTypeSelected.includes("14 Yard") ||
        // 	skipTypeSelected.includes("12 Yard")
        // ) {
        // Hide Order & Pay Option
        booking_step_five.classList.remove("flex");
        booking_step_five.classList.add("hidden");
        booking_confirmation.classList.remove("flex");
        booking_confirmation.classList.add("hidden");
        // Display Additional Info Required Form
        booking_additional_info_form.classList.remove("hidden");
        booking_additional_info_form.classList.add("flex");
        // Change Timeline Progress Confirmation Text
        timeline_progress_step_six.innerHTML = "Enquiry Form";
        // }
    };
    displayAdditionalInfoRequiredForm();
    //getAddress.find('postcode_lookup','Z2vt1DoxXEa7MWrhvwOg0Q21153');
    var waste_selection_id = "";
    var waste_selection_term = "";
    var waste_radios = document.getElementsByName("waste-select");
    var _loop = function _loop(_i) {
        waste_radios[_i].addEventListener("change", function (e) {
            for (var _i6 = 0; _i6 < waste_radios.length; _i6++) {
                waste_radios[_i6].parentElement.classList.remove("selected");
            }
            waste_radios[_i].parentElement.classList.add("selected");
            document.getElementById("skip-sizes").innerHTML = "";
            document.getElementById("skip-types").innerHTML = "";
            /*
            
            1. Reset Form Fields,
            2. Reset Additional Info Required Form Fields & Gravity Form
            3. Removes Additional Info Required Form
                  4. Add/ Returns the user ability to order a skip
                  */
            resetFormFields();
            resetAdditionalInfoRequiredFormFields();
            waste_selection_id = waste_radios[_i].value;
            waste_selection_term = waste_radios[_i].parentElement.querySelector("span").innerHTML;
            var formData = new FormData();
            formData.append("action", "booking_form_sizes");
            formData.append("waste_id", waste_selection_id);
            formData.append("waste_term", waste_selection_term);
            fetch(booking_days.ajaxurl, {
                method: "POST",
                body: formData
            }).then(function (res) {
                return res.text();
            })
                //.then( data => console.log( data ) )
                .then(function (data) {
                document.getElementById("skip-sizes-empty").style.display = "none";
                document.getElementById("skip-types-empty-waste").style.display = "none";
                document.getElementById("skip-types-empty-sizes").style.display = "block";
                document.querySelector("#skip-sizes").innerHTML = data;
                document.getElementById("booking_step_two").scrollIntoView({
                    behavior: "smooth"
                });
                document.getElementById("timeline_progress_step_two").classList.add("active");
            }).catch(function (err) {
                return console.log(err);
            });
        });
    };
    for (var _i = 0; _i < waste_radios.length; _i++) {
        _loop(_i);
    }
    var size_selection_id = "";
    var skip_selected = "";
    var skip_radios = document.getElementsByName("skip-size");
    var types_radios = document.getElementsByName("skip-type");
    document.body.addEventListener("click", function (event) {
        for (var _i2 = 0; _i2 < skip_radios.length; _i2++) {
            skip_radios[_i2].parentElement.classList.remove("selected");
        }
        for (var _i3 = 0; _i3 < types_radios.length; _i3++) {
            types_radios[_i3].parentElement.classList.remove("selected");
        }
        if (event.target.name == "skip-size") {
            event.target.parentElement.classList.add("selected");
            size_selection_id = event.target.value;
            document.getElementById("skip-types").innerHTML = "";
            var typeformData = new FormData();
            typeformData.append("action", "booking_form_type");
            typeformData.append("skip_id", size_selection_id);
            typeformData.append("waste_type", waste_selection_term);
            fetch(booking_days.ajaxurl, {
                method: "POST",
                body: typeformData
            }).then(function (res) {
                return res.text();
            })
                //.then( data => console.log( data ) )
                .then(function (data) {
                document.getElementById("skip-types-empty-sizes").style.display = "none";
                document.querySelector("#skip-types").innerHTML = data;
                document.querySelector("#waste-value").innerHTML = waste_selection_term;
                // Additional Info Required Form - Waste Type Field
                additionalInfoWasteValue.innerHTML = waste_selection_term;
                // Gravity Form Waste Type Field - (Additional Info Required Form)
                WasteType.value = waste_selection_term;
                WasteType.innerHTML = waste_selection_term;
                WasteType.placeholder = waste_selection_term;
                document.getElementById("types-title").scrollIntoView({
                    behavior: "smooth"
                });
                document.getElementById("timeline_progress_step_three").classList.add("active");
            }).catch(function (err) {
                return console.log(err);
            });
        }
        if (event.target.name == "skip-type") {
            skip_selected = event.target.value;
            event.target.parentElement.classList.add("selected");
            var typeformData = new FormData();
            typeformData.append("action", "booking_form_save");
            typeformData.append("selected_skip_id", skip_selected);
            fetch(booking_days.ajaxurl, {
                method: "POST",
                body: typeformData
            }).then(function (res) {
                return res.text();
            })
                //.then( data => console.log( data ) )
                .then(function (data) {
                var typeformData = new FormData();
                typeformData.append("action", "booking_form_skip_name");
                typeformData.append("selected_skip_id", skip_selected);
                fetch(booking_days.ajaxurl, {
                    method: "POST",
                    body: typeformData
                }).then(function (res) {
                    return res.text();
                })
                    //.then( data => console.log( data ) )
                    .then(function (data) {
                    /* Display Additional Info Required Form &
                      Removes the user ability to order a skip*/
                    displayAdditionalInfoRequiredForm(waste_selection_term, data);
                    document.getElementById("size-value").innerHTML = data;
                    // Additional Info Required Form - Skip Size Value Field
                    additionalInfoSizeValue.innerHTML = data;
                    // Gravity Form Skip Type Field - (Additional Info Required Form)
                    skipType.value = data;
                    skipType.innerHTML = data;
                    skipType.placeholder = data;
                    document.getElementById("booking_step_three").scrollIntoView({
                        behavior: "smooth"
                    });
                    document.getElementById("timeline_progress_step_four").classList.add("active");
                    /* Only enable the Driveway type radio button input field
                     once user has fill in all other required fields */
                    document.getElementById("private-driveway").disabled = false;
                    document.getElementById("public-driveway").disabled = false;
                    document.getElementById("private-driveway-wrapper").classList.add("active");
                    document.getElementById("public-driveway-wrapper").classList.add("active");
                }).catch(function (err) {
                    return console.log(err);
                });
            }).catch(function (err) {
                return console.log(err);
            });
        }
    });
    var selected_driveway_option = "";
    var driveway_options = document.getElementsByName("driveway");
    var _loop2 = function _loop2(_i4) {
        driveway_options[_i4].addEventListener("change", function (e) {
            for (var _i7 = 0; _i7 < driveway_options.length; _i7++) {
                driveway_options[_i7].parentElement.classList.remove("selected");
            }
            driveway_options[_i4].parentElement.classList.add("selected");
            selected_driveway_option = driveway_options[_i4].value;
            var formData = new FormData();
            formData.append("action", "booking_form_driveway");
            formData.append("driveway", selected_driveway_option);
            fetch(booking_days.ajaxurl, {
                method: "POST",
                body: formData
            }).then(function (res) {
                return res.text();
            })
                //.then( data => console.log( data ) )
                .then(function (data) {
                // Order And Pay - WooCommerce
                drivewaySelection.value = data;
                drivewaySelection.innerHTML = data;
                drivewaySelection.placeholder = data;
                // Additional Info Required Form - Driveway Selection Field
                additionalInfoDrivewaySelection.value = data;
                additionalInfoDrivewaySelection.innerHTML = data;
                additionalInfoDrivewaySelection.placeholder = data;
                // Gravity Form Permit Type Field - (Additional Info Required Form)
                permitType.value = data;
                permitType.innerHTML = data;
                permitType.placeholder = data;
                /* Permit / Driveway Type has a tenancy
                to be empty on Waste Type re-selection for a
                random reason can't determine the bug.
                So this is a fall back */
                if (!permitType.value || permitType.value == null || !drivewaySelection.value || drivewaySelection.value == null) {
                    drivewayError.style.display = "block";
                    drivewayError.scrollIntoView({
                        behavior: "smooth"
                    });
                }
                selected_driveway_section.scrollIntoView({
                    behavior: "smooth"
                });
                timeline_progress_step_five.classList.add("active");
                /* Only enable the Postcode search input field and
                button once user has fill in all other required fields */
                document.getElementById("postcode").disabled = false;
                document.getElementById("postcode-valid").disabled = false;
                document.getElementById("submit-postcode").disabled = false;
            }).catch(function (err) {
                return console.log(err);
            });
        });
    };
    for (var _i4 = 0; _i4 < driveway_options.length; _i4++) {
        _loop2(_i4);
    }
    var postcode = "";
    var postcode_input = document.getElementById("postcode");
    var postcode_btn = document.getElementById("submit-postcode");
    postcode_btn.addEventListener("click", function () {
        postcode = postcode_input.value;
        if (postcode.length > 6 && postcode.length < 9) {
            var formData = new FormData();
            formData.append("action", "booking_form_postcode");
            formData.append("postcode", postcode);
            formData.append("skip_id", skip_selected);
            fetch(booking_days.ajaxurl, {
                method: "POST",
                body: formData
            }).then(function (res) {
                return res.text();
            }).then(function (data) {
                document.getElementById("postcode-valid-error").style.display = "none";
                if (data == "false") {
                    document.getElementById("postcode-valid-error").innerHTML = "";
                    document.getElementById("postcode-valid-error").innerHTML = "Please call us on 01452 536536 for delivery options to that postcode";
                    document.getElementById("postcode-valid-error").style.display = "block";
                    document.getElementById("postcode-valid").value = "false";
                }
                else if (data == "error") {
                    document.getElementById("postcode-valid-error").innerHTML = "";
                    document.getElementById("postcode-valid-error").innerHTML = "There is a skip in your cart, please empty your cart before adding another.";
                    document.getElementById("postcode-valid-error").style.display = "block";
                    document.getElementById("postcode-valid").value = "false";
                }
                else {
                    document.getElementById("postcode-valid-error").style.display = "none";
                    document.getElementById("postcode-valid-error").innerHTML = "";
                    document.getElementById("postcode-valid").value = "true";
                    document.getElementById("postcode-success").style.display = "block";
                    // Gravity Form Postcode Field - (Additional Info Required Form)
                    postcodeType.value = postcode;
                    postcodeType.innerHTML = postcode;
                    postcodeType.placeholder = postcode;
                    var subtotal = Number(data);
                    subtotal.toFixed(2);
                    var vat_price = subtotal / 5;
                    vat_price = vat_price.toFixed(2);
                    vat_price = Number(vat_price);
                    var total_price = vat_price + subtotal;
                    //total_price = Number(total_price);
                    total_price = total_price.toFixed(2);
                    document.querySelector("#subtotal-value").innerHTML = subtotal;
                    document.querySelector("#vat-value").innerHTML = vat_price;
                    document.querySelector("#total-value").innerHTML = total_price;
                    // Gravity Form Postcode Field - (Additional Info Required Form)
                    subtotalType.value = "\xA3".concat(subtotal);
                    subtotalType.innerHTML = "\xA3".concat(subtotal);
                    subtotalType.placeholder = "\xA3".concat(subtotal);
                    VATType.value = "\xA3".concat(vat_price);
                    VATType.innerHTML = "\xA3".concat(vat_price);
                    VATType.placeholder = "\xA3".concat(vat_price);
                    totalType.value = "\xA3".concat(total_price);
                    totalType.innerHTML = "\xA3".concat(total_price);
                    totalType.placeholder = "\xA3".concat(total_price);
                    /* Only enable Datepicker (Delivery & Collection Date) input
                    fields once user has fill in all other required fields */
                    document.getElementById("delivery-date-value").disabled = false;
                    document.getElementById("collection-date-value").disabled = false;
                }
                //console.log(data);
            }).catch(function (err) {
                return console.log(err);
            });
        }
        else {
            document.getElementById("postcode-valid-error").innerHTML = "";
            document.getElementById("postcode-valid-error").innerHTML = "Please enter a valid UK postcode";
            document.getElementById("postcode-valid-error").style.display = "block";
            document.getElementById("postcode-valid").value = "false";
        }
    });
    // Date Picker Settings
    var unavailable = booking_days.unavailable;
    var unavailable_dates = [];
    for (var i = 0, l = unavailable.length; i < l; i++) {
        for (var _i5 = 0, _Object$entries = Object.entries(unavailable[i]); _i5 < _Object$entries.length; _i5++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i5], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
            var date_formatted = unavailable[i].date;
            date_formatted = date_formatted.split("-");
            var day = date_formatted[2];
            var month = date_formatted[1];
            month = String(month - 1);
            var year = date_formatted[0];
            // let date = [];
            // date.push(day);
            // date.push(month);
            // date.push(year);
            var unavailable_date = new Date(year, month, day);
            //unavailable_date = unavailable_date.toISOString().slice(0,10);
            //console.log(unavailable_date);
            unavailable_dates.push(unavailable_date);
        }
    }
    var today = new Date();
    // Delivery Day
    var booking_min_days = booking_days.min;
    booking_min_days = Number(booking_min_days);
    var booking_min = new Date();
    booking_min.setDate(today.getDate() + booking_min_days);
    var booking_min_formatted = booking_min.toISOString().slice(0, 10);
    booking_min_formatted = booking_min_formatted.split("-");
    var booking_min_day = booking_min_formatted[2];
    var booking_min_month = booking_min_formatted[1];
    booking_min_month = booking_min_month - 1;
    var booking_min_year = booking_min_formatted[0];
    var booking_max_days = booking_days.max;
    booking_max_days = Number(booking_max_days);
    var booking_max = new Date();
    booking_max.setDate(today.getDate() + booking_max_days);
    var booking_max_formatted = booking_max.toISOString().slice(0, 10);
    booking_max_formatted = booking_max_formatted.split("-");
    var booking_max_day = booking_max_formatted[2];
    var booking_max_month = booking_max_formatted[1];
    booking_max_month = booking_max_month - 1;
    var booking_max_year = booking_max_formatted[0];
    var deliveryDayPicker = function deliveryDayPicker() {
        var selected_date = datepicker("#delivery-date-value", {
            disabledDates: unavailable_dates,
            disableYearOverlay: true,
            maxDate: new Date(booking_max_year, booking_max_month, booking_max_day),
            minDate: new Date(booking_min_year, booking_min_month, booking_min_day),
            noWeekends: true,
            onSelect: function onSelect(instance, date) {
                var formData = new FormData();
                formData.append("action", "booking_form_delivery");
                formData.append("delivery_date", date);
                fetch(booking_days.ajaxurl, {
                    method: "POST",
                    body: formData
                }).then(function (res) {
                    return res.text();
                })
                    // .then((data) => console.log(data))
                    .then(function (data) {
                    // Gravity Form Delivery Date Field - (Additional Info Required Form)
                    deliveryDateType.value = date;
                    deliveryDateType.innerHTML = date;
                    deliveryDateType.placeholder = date;
                    // document.querySelector("#delivery-date").innerHTML = data;
                    // return data;
                }).catch(function (err) {
                    return console.log(err);
                });
                // ACF Fields Client Number of minimum days
                var collectionMinimumDateNumber = booking_days.collection;
                collectionMinimumDateNumber = Number(collectionMinimumDateNumber);
                var collectionMaximumDateNumber = booking_days.collectionmax;
                collectionMaximumDateNumber = Number(collectionMaximumDateNumber);
                // Calculate the future minimum and maximum date
                // const futureDate = getFutureDate(date, collectionMinimumDate);
                var futureMinimumAndMaximumDate = getFutureMinimumAndMaximumCollectionDates(date, collectionMinimumDateNumber, collectionMaximumDateNumber);
                // Sends the min selected date to the collection date function
                collectionDayPicker(futureMinimumAndMaximumDate);
            }
        });
        return selected_date;
    };
    // Function to add days to a date
    var addDays = function addDays(date, days) {
        var result = new Date(date);
        result.setDate(date.getDate() + days);
        return result;
    };
    // Function to format date to day, month, year
    var dateFormatInDayMonthYear = function dateFormatInDayMonthYear(date) {
        var formattedDate = dateFormat(date, "dd/mm/yyyy");
        var parts = formattedDate.split("/");
        // Datepicker Doc Months begin from 0 not 1
        var day = parts[0];
        var month = parts[1] - 1;
        var year = parts[2];
        var dayMonthYear = {
            day: day,
            month: month,
            year: year
        };
        return dayMonthYear;
    };
    var getFutureMinimumAndMaximumCollectionDates = function getFutureMinimumAndMaximumCollectionDates(date, collectionMinimumDateNumber, collectionMaximumDateNumber) {
        /* Gets the selected date and adds the minimum collection days number.
        Then gets the returned future minimum collection day and adds the
        maximum collection days number to return the future maximum collection
        day */
        var futureMinimumDate = addDays(date, collectionMinimumDateNumber);
        var futureMaximumDate = addDays(futureMinimumDate, collectionMaximumDateNumber);
        // Return future minimum and maximum date as {Day, Month & Year}
        var futureMinimumDayMonthYear = dateFormatInDayMonthYear(futureMinimumDate);
        var futureMaximumDayMonthYear = dateFormatInDayMonthYear(futureMaximumDate);
        var minMaxDates = {
            minDay: futureMinimumDayMonthYear,
            maxDay: futureMaximumDayMonthYear
        };
        return minMaxDates;
    };
    var collectionDayPicker = function collectionDayPicker(minMaxDates) {
        // Future Collection Minimum Date (Day, Month, Year)
        var collection_min_day = minMaxDates.minDay.day;
        var collection_min_month = minMaxDates.minDay.month;
        var collection_min_year = minMaxDates.minDay.year;
        var collection_max_day = minMaxDates.maxDay.day;
        var collection_max_month = minMaxDates.maxDay.month;
        var collection_max_year = minMaxDates.maxDay.year;
        datepicker("#collection-date-value", {
            disabledDates: unavailable_dates,
            disableYearOverlay: true,
            maxDate: new Date(collection_max_year, collection_max_month, collection_max_day),
            minDate: new Date(collection_min_year, collection_min_month, collection_min_day),
            noWeekends: true,
            onSelect: function onSelect(instance, date) {
                var formData = new FormData();
                formData.append("action", "booking_form_collection");
                formData.append("collection_date", date);
                fetch(booking_days.ajaxurl, {
                    method: "POST",
                    body: formData
                }).then(function (res) {
                    return res.text();
                })
                    //.then( data => console.log( data ) )
                    .then(function (data) {
                    document.querySelector("#delivery-date").innerHTML = data;
                    // Gravity Form Collection Date Field - (Additional Info Required Form)
                    collectionDateType.value = date;
                    collectionDateType.innerHTML = date;
                    collectionDateType.placeholder = date;
                    if (bookingFormInputFieldSelectionFinalCheck()) {
                        /* Smooth Scroll to Additional Info Required Form
                        or to the Order & Pay Confirmation Section */
                        if (waste_selection_term != "Mixed" || skipType.includes("enclosed") || skipType.value.includes("14 Yard") || skipType.value.includes("12 Yard")) {
                            booking_additional_info_form.scrollIntoView({
                                behavior: "smooth"
                            });
                        }
                        else {
                            booking_step_five.scrollIntoView({
                                behavior: "smooth"
                            });
                            /* Only enable the form submit button once user
                            has fill in all the required field*/
                            submitForm.disabled = false;
                        }
                        timeline_progress_step_six.classList.add("active");
                    }
                    else {
                        alert("Please re-select missing form fields and any errors in red above.");
                        bookingFormInputFieldSelectionFinalCheck();
                    }
                }).catch(function (err) {
                    return console.log(err);
                });
            }
        });
    };
    deliveryDayPicker();
    // Replacement Skip
    var replacementSkip = function replacementSkip() {
        var replacement_skip_value = false;
        var replacement_skip = document.getElementById("replacement-skip-value");
        replacement_skip.addEventListener("change", function (event) {
            if (event.currentTarget.checked) {
                replacement_skip_value = "true";
            }
            else {
                replacement_skip_value = "false";
            }
            var formData = new FormData();
            formData.append("action", "booking_form_replacement");
            formData.append("replacement_skip_value", replacement_skip_value);
            formData.append("skip_id", skip_selected);
            fetch(booking_days.ajaxurl, {
                method: "POST",
                body: formData
            }).then(function (res) {
                return res.text();
            }).then(function (data) {
                // Gravity Form Replacement Field - (Additional Info Required Form)
                replacementType.value = "Replace my existing Skip";
                replacementType.innerHTML = "Replace my existing Skip";
                replacementType.placeholder = "Replace my existing Skip";
                // document.querySelector("#delivery-date").innerHTML = data;
                /* Smooth Scroll to Additional Info Required Form
                or to the Order & Pay Confirmation Section */
                // if (
                // 	waste_selection_term != "Mixed" ||
                // 	skipType.value.includes("14 Yard") ||
                // 	skipType.value.includes("12 Yard")
                // ) {
                // 	booking_additional_info_form.scrollIntoView({behavior: "smooth"});
                // } else {
                booking_step_five.scrollIntoView({
                    behavior: "smooth"
                });
                /* Only enable the form submit button once user
                    has fill in all the required field*/
                submitForm.disabled = false;
                // }
                timeline_progress_step_six.classList.add("active");
            }).catch(function (err) {
                return console.log(err);
            });
        });
    };
    replacementSkip();
    // Form navigate to selected url
    var navigateTo = function navigateTo(slug) {
        // Construct the URL
        var url = "".concat(window.location.origin, "/").concat(slug);
        // console.log(url);
        // Redirect to the new URL
        window.location.href = url;
    };
    /* Booking Form Input Selection Final Check
    Ensure no missing fields */
    var bookingFormInputFieldSelectionFinalCheck = function bookingFormInputFieldSelectionFinalCheck() {
        var proceedToPaymentOrAdditionalInfoForm = false;
        if (!WasteType.value || WasteType.value == null) {
            WasteTypeError.classList.remove("hidden");
            WasteTypeError.classList.add("block");
            WasteTypeError.scrollIntoView({
                behavior: "smooth"
            });
        }
        else if (!skipType.value || skipType.value == null) {
            skipTypeError.classList.remove("hidden");
            skipTypeError.classList.add("block");
            skipTypeError.scrollIntoView({
                behavior: "smooth"
            });
        }
        else if (!permitType.value || permitType.value == null) {
            drivewayError.classList.remove("hidden");
            drivewayError.classList.add("block");
            drivewayError.scrollIntoView({
                behavior: "smooth"
            });
        }
        else if (!postcodeType.value || postcodeType.value == null) {
            postcodeError.classList.remove("hidden");
            postcodeError.classList.add("block");
            postcodeError.scrollIntoView({
                behavior: "smooth"
            });
        }
        else if (!deliveryDateType.value || deliveryDateType.value == null) {
            deliveryDateError.classList.remove("hidden");
            deliveryDateError.classList.add("block");
            deliveryDateError.scrollIntoView({
                behavior: "smooth"
            });
        }
        else if (!collectionDateType.value || collectionDateType.value == null) {
            collectionDateError.classList.remove("hidden");
            collectionDateError.classList.add("block");
            collectionDateError.scrollIntoView({
                behavior: "smooth"
            });
        }
        else {
            proceedToPaymentOrAdditionalInfoForm = true;
        }
        return proceedToPaymentOrAdditionalInfoForm;
    };
    // SUBMIT BOOKING ORDER //
    /* Submit Order And Pay Button */
    submitForm.addEventListener("click", function () {
        if (bookingFormInputFieldSelectionFinalCheck()) {
            navigateTo("cart");
        }
        else {
            alert("Please re-select missing form fields and any errors in red above.");
            bookingFormInputFieldSelectionFinalCheck();
        }
    });
    /* CHECKOUT PAGE (Code Block)
    
    - This code block is required in the WYSIWYG section
    in the backend of the page editor for the styling of
    the front end to appear correctly.
    
    This is only needed because og the WooCommerce Blink
    Payment Gateway Plugin.
    
    Code:
    
    <!-- wp:woocommerce/checkout {"requirePhoneField":true} -->
    <div class="wp-block-woocommerce-checkout alignwide wc-block-checkout is-loading"><!-- wp:woocommerce/checkout-fields-block -->
    <div class="wp-block-woocommerce-checkout-fields-block"><!-- wp:woocommerce/checkout-express-payment-block --></div>
    <div class="wp-block-woocommerce-checkout-totals-block">
    <div class="wp-block-woocommerce-checkout-order-summary-block">
    <div class="wp-block-woocommerce-checkout-order-summary-totals-block">
    <div class="wp-block-woocommerce-checkout-order-summary-subtotal-block">
    <p>[woocommerce_checkout]</p>
    </div>
    <!-- /wp:woocommerce/checkout-order-summary-taxes-block --></div>
    <!-- /wp:woocommerce/checkout-order-summary-totals-block --></div>
    <!-- /wp:woocommerce/checkout-order-summary-block --></div>
    <!-- /wp:woocommerce/checkout-totals-block --></div>
    <!-- /wp:woocommerce/checkout -->
    
    */
}
